import { Component, OnInit, Input } from '@angular/core';
import { CreateUser, ViewDetails, GetRequestActivity, ContactPatientRequest } from 'src/app/models/supportcreateuser';
import { SupportService } from 'src/app/services/support.service';
import { PromiseResult, ErrorModel, ServerError, ApiResult } from 'src/app/models/PromiseResult';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { TokenService } from '../../../../utilities/token.service';
import { ROLES } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-view-user-details1',
  templateUrl: './view-user-details.component.html',
  styleUrls: ['./view-user-details.component.css', '../../../../../assets/css/custom-egd.css']
})
export class ViewUserDetailsComponent implements OnInit {

  createUser: CreateUser = new CreateUser();
  slug: string ="";

  constructor(private supportservice: SupportService, private route: ActivatedRoute,
    private readonly breadcrumbService: DoctorBreadcrumbService,
    private readonly tokenUtil: TokenService,
    private readonly providerStateService: ProviderStateService
  ) {
    
    this.createUser.other_view_details.roles = ROLES;
  }


  async ngOnInit() {
    this.slug = this.providerStateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'support']},
      { label: 'View Details' },
      { label: 'Support' }
    ]);
    this.route.params.subscribe(async (params) => {
      this.createUser.other_view_details.req_id = Number(params.req_id);
    });
    await this.getPatientInfo(this.createUser.other_view_details.req_id);
    // await this.getrequestactivity(this.req_id);
    this.createUser.other_view_details.medical_profession_role = this.tokenUtil.findRoleId();
    if (this.createUser.other_view_details.medical_profession_role == ROLES.Support)
      this.createUser.other_view_details.is_support_role = true;
  }

  showdialog() {
    this.createUser.display = true;
  }
  async getPatientInfo(request_id: number) {
    this.createUser.posting = true;
    this.createUser.loading = true;
    await this.supportservice.fetchPateintDetails(request_id).toPromise()
      .then((result) => {
        this.createUser.create_api_result.PromiseResult = result;
        if (result.success) {

          this.createUser.success = true;
          this.createUser.viewDetails = result.data;
          this.createUser.viewDetails.consultation_name = result.data.consultationType[0].consultation_type.consultation_name;
          if (result.data.request_activity.length > 0) {
            this.createUser.other_view_details.isactivity = true;
            let temp: GetRequestActivity[] = [];
            result.data.request_activity.forEach(async element => {
              temp.push({
                timestamp: element.timestamp,
                action: element.action

              })
            });
            this.createUser.other_view_details.activities_list = temp;

          }
          if (result.data.contact_patient_request.length > 0) {
            this.createUser.other_view_details.isPatientContactActivity = true;
            let temp: ContactPatientRequest[] = [];
            result.data.contact_patient_request.forEach(async element => {
              temp.push({
                id: element.id,
                reason: element.reason,
                comments: element.comments,
                first_name: element.egd_users.first_name,
                last_name: element.egd_users.last_name
              })
            });
            this.createUser.other_view_details.patient_contacted_list = temp;
          }

        }

        this.createUser.posting = false;
        this.createUser.loading = false;
      });
      this.createUser.create_api_result.PromiseResult.success = false;
    this.createUser.posting = false;
    this.createUser.loading = false;
  }

  async contactPatient() {
    this.createUser.create_api_result = new ApiResult(true);
    this.createUser.contactUser.req_id = this.createUser.other_view_details.req_id;
    await this.supportservice
      .ContactUser(this.createUser.contactUser)
      .toPromise()
      .then((result) => {
        if(result.success)
        {
          this.createUser.create_api_result.PromiseResult = result;
          this.createUser.create_api_result.Posting = false;
          this.getPatientInfo(this.createUser.other_view_details.req_id);
          this.createUser.display = false;
          this.createUser.contactUser.reason = '';
          this.createUser.contactUser.comments = '';
        }
       
      })
      .catch((error: HttpErrorResponse) => {
        this.createUser.create_api_result.ServerError = error.error;
        this.createUser.create_api_result.PromiseResult.success = false;
        this.createUser.create_api_result.Posting = false;
      });
  }

  isPosting(): boolean {
    return this.createUser.create_api_result.Posting;
  }
}

